import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IdentityStorage } from '../_models/identity.storage';
import { Observable, BehaviorSubject } from 'rxjs';
import { Identity } from '../_models/identity';
import { LocalStorageService } from 'angular-web-storage';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UserService } from '../../service/user/user.service';
import { map } from 'rxjs/operators';


class AuthorityResponse {
    public authority: string;
}

class UserPerfilResponse {
    public nome: string;
    public descricao: string;
    public email: string;
    public comarca: string;
    public lotacao: string;
    public cargo: string;
    public cpf: string;
}

class UserDataResponse {
    public id: string;
    public nome: string;
    public perfis: UserPerfilResponse[];
}

class AuthenticationResponse {
    public id: number;
    public cpf: string;
    public login: string;
    public nome: string;
    public token: string;
    public primeiroAcesso: boolean;
}

class AuthenticationResult {
    ok: boolean;
    primeiroAcesso: boolean;
    id: number;
    message: string;

    constructor(ok: boolean, primeiroAcesso: boolean, id: number, message: string) {
        this.ok = ok;
        this.primeiroAcesso = primeiroAcesso;
        this.id = id;
        this.message = message;
    }
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    baseUrl = environment.url;

    private messageSource = new BehaviorSubject(false);

    public message = this.messageSource.asObservable();

    constructor(
        private http: HttpClient,
        private userService: UserService,
        public identityStorage: IdentityStorage,
        public local: LocalStorageService,
        private router: Router,
        private toasterService: ToastrService,
    ) {
    }

    authenticate(login: string, password: string): Observable<AuthenticationResult> {

        // const credentials = JSON.stringify({ login: login, senha: password });
        const credentials = { login: login, password: password };

        return this.http.post<AuthenticationResponse>(this.baseUrl + 'v1/auth', credentials).pipe(
            map(resp => {
                if (resp.token) {
                    const token = resp.token;
                    const cpf = resp.login;
                    const id = resp.id;
                    const userName = resp.nome
                    const primeiroAcesso = resp.primeiroAcesso
                    // const perfil = this.getPerfis(resp.user.perfis);
                    this.local.set('idUsuario', id);
                    if (token) {
                        const userAuthData = {
                            token: token,
                            userName: userName,
                            id: id,
                            cpf: cpf,
                            primeiroAcesso: primeiroAcesso
                            // perfil: perfil
                        };
                        //console.log(`Usuário autenticou: Nome: ${userName}`);
                        this.identityStorage.saveAuthData(userAuthData);
                        this.local.set('loggedUser', userAuthData);
                        this.messageSource.next(true);
                        return new AuthenticationResult(true, primeiroAcesso, id, null);
                    }
                } else {
                    this.messageSource.next(false);
                    // this.toasterService.error('A sessão expirou, por favor realize o login.');
                    return new AuthenticationResult(false, false, 0, 'Login ou Senha Inválidos');

                }
            })
        );
    }

    isExpired() {

        this.userService.sessao().subscribe(_ => { }, _ => {
            this.toasterService.error('A sessão expirou, por favor realize o login.');
            this.identityStorage.clearAuthData();
            this.router.navigate(['login']);
        });
    }


    getIdentity(): Identity {
        return this.identityStorage.getIdentity();
    }

    isAuthenticated(): boolean {
        return this.identityStorage.authenticationPresent();
    }

    clearAuthentication(): void {
        this.identityStorage.clearAuthData();
    }

    getPerfis(perfis: Array<UserPerfilResponse>) {
        let perfilArray = '';
        if (perfis != null) {
            perfis.forEach(element => {
                perfilArray += element.nome;
            });
        }
        return perfilArray;
    }

    isAdminSistema(): boolean {
        let retorno = false;
        this.getIdentity().perfil.split(',').forEach(element => {
            if (element === 'ADMINISTRADOR') {
                retorno = true;
            }
        });
        return retorno;
    }
}
